import { useEffect, useRef, useState } from "react";
import "./TopSection.scss";
import { getCategories } from "../../../services/products";
import { useCookies } from "react-cookie";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import { Navigation } from "swiper/modules";

export default function TopSection({ active, setActive }) {
  const { t } = useTranslation();
  const [cookie] = useCookies(["access_token"]);

  const [categories, setCategories] = useState([]);
  const [endItem, setEndItem] = useState(
    /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) ? 2 : 4,
  );
  const deviceType = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
    ? "mobile"
    : "desktop";

  useEffect(() => {
    cookie?.access_token &&
      getCategories(cookie?.access_token).then(
        (res) => res && setCategories(res.sort((a, b) => a.id - b.id)),
      );
  }, [cookie?.access_token]);

  useEffect(() => {
    if (categories?.length > 0 && categories?.length < endItem) {
      setEndItem(categories?.length);
    }
  }, [categories]);

  const [isFixed, setIsFixed] = useState(false);
  const isFixedRef = useRef(false);

  useEffect(() => {
    const handleScroll = () => {
      const targetDiv = document.getElementById("promo-categories");
      if (!targetDiv) return;

      const rect = targetDiv.getBoundingClientRect();

      if (deviceType === "desktop") {
        if (rect.top <= 95 && !isFixedRef.current) {
          setIsFixed(true);
          isFixedRef.current = true;
        } else if (window.scrollY <= 550 && isFixedRef.current) {
          setIsFixed(false);
          isFixedRef.current = false;
        }
      } else {
        if (rect.top <= 0 && !isFixedRef.current) {
          setIsFixed(true);
          isFixedRef.current = true;
        } else if (window.scrollY <= 450 && isFixedRef.current) {
          setIsFixed(false);
          isFixedRef.current = false;
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [deviceType]);

  return (
    <div className="promo-top-section">
      <div className="title-description">
        <div className="title">
          <p>{t("promotions")}</p>
        </div>
        <div className="description">
          <p>{t("promo-description")}</p>
        </div>
      </div>
      {categories?.length > 0 && (
        <Swiper
          modules={[Navigation]}
          slidesPerView={endItem}
          navigation={true}
          centeredSlides={false}
          loop={false}
          direction="horizontal"
          observeParents={true}
          parallax={true}
          className={`${isFixed ? "fixed" : ""}`}
          id="promo-categories"
        >
          {categories.map((category) => {
            return (
              <SwiperSlide key={category.id}>
                <div className="menu-item">
                  <p
                    className={
                      Number(active) === Number(category.id)
                        ? "item-name active"
                        : "item-name"
                    }
                    onClick={() => {
                      setActive(category.id);
                    }}
                  >
                    {t(category.name)}
                  </p>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      )}
    </div>
  );
}
